import axios from 'axios';
import api from './api';

export type AccessKeyStatusResponse = {
  enabled: boolean;
};

export type AccessKeyVerifyResponse = {
  valid: boolean;
};

export type AppAccessKeySettingsResponse = {
  enabled: boolean;
  access_key: string;
};

/**
 * 접근 키 게이트는 axios.defaults.baseURL(API_ORIGIN)을 쓰지 않는다.
 * HTTPS 뒤에서 API_ORIGIN 이 http://127.0.0.1:9001 이면 원격 브라우저가
 * 자기 localhost 로 요청해 실패한다. 페이지 origin(= CRA 프록시 또는 nginx)으로만 호출.
 */
function pageOriginAxios() {
  const baseURL =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : '';
  return axios.create({ baseURL });
}

export async function fetchAccessKeyGateStatus(): Promise<AccessKeyStatusResponse> {
  const { data } = await pageOriginAxios().get<AccessKeyStatusResponse>(
    '/api/access-key/status'
  );
  return data;
}

export async function verifyAccessKeyWithServer(key: string): Promise<boolean> {
  const { data } = await pageOriginAxios().post<AccessKeyVerifyResponse>(
    '/api/access-key/verify',
    { key }
  );
  return Boolean(data.valid);
}

export async function fetchAppAccessKeySettings(): Promise<AppAccessKeySettingsResponse> {
  const data = (await api.get('/api/settings/app-access-key')) as AppAccessKeySettingsResponse & {
    value?: string;
    key?: string;
  };
  if (data && typeof data.access_key === 'string') {
    return {
      enabled: Boolean(data.enabled),
      access_key: data.access_key,
    };
  }
  if (data?.value != null && String(data.key || '').includes('app_access')) {
    const v = String(data.value).trim();
    return { enabled: Boolean(v), access_key: v };
  }
  return { enabled: false, access_key: '' };
}

export async function updateAppAccessKeySettings(payload: {
  username: string;
  password: string;
  access_key: string;
}): Promise<{ success: boolean; message?: string }> {
  const data = await api.put<{ success: boolean; message?: string }>(
    '/api/settings/app-access-key',
    payload
  );
  return data ?? { success: true };
}
